// components/ItemImage.jsx
import React from 'react';
import { discountUtils } from '../utils/discountUtils';
import { getLocalizedText } from '../../../../utils/multilingualUtils';

const ItemImage = ({
    item,
    showDiscountInfo,
    showWishlistToggle,
    WishlistComponent
}) => {
    const handleImageError = (e) => {
        e.target.onerror = null;
        e.target.src = "/placeholder.png";
    };

    return (
        <div className="item-image-container">
            {/* Discount Badge */}
            {showDiscountInfo && discountUtils.hasDiscount(item) && (
                <div
                    className={`item-discount-badge ${discountUtils.getDiscountBadgeClass(item)}`}
                >
                    {discountUtils.getDiscountLabel(item)}
                </div>
            )}

            {/* Wishlist Toggle */}
            {showWishlistToggle && WishlistComponent && (
                <div className="item-wishlist-toggle">
                    <WishlistComponent
                        product={{
                            id: item.productId || item.id,
                            name: item.name,
                            price: item.price,
                            images: [item.image || item.images?.[0]],
                            storeId: item.storeId,
                        }}
                        variantId={item.variantId}
                        className="cart-wishlist-btn"
                    />
                </div>
            )}

            {/* Item Image */}
            {item.image || item.images?.[0] ? (
                <img
                    src={item.image || item.images[0]}
                    alt={getLocalizedText(item.name, 'en') || "Product"}
                    className="item-image"
                    onError={handleImageError}
                />
            ) : (
                <div className="item-placeholder">
                    <span>No Image</span>
                </div>
            )}
        </div>
    );
};

export default ItemImage;